import jQuery from 'jquery';

;(function ($) {

  const $mobilityData = $('[data-id="MobilityDataContainer"]');

  if (!$mobilityData.length) return;

  $mobilityData.each(function () {

    const $Data = $(this);
    const $DataBlock = $Data.find('[data-id="DataBlock"]');
    const $DataDate = $Data.find('[data-id="DataDate"]');
    const $DataCount = $Data.find('[data-id="DataCount"]');
    const $DataKm = $Data.find('[data-id="DataKm"]');
    const $DataEarth = $Data.find('[data-id="DataEarth"]');
    const intervalTime = 3000; //更新頻度（ms）
    const earthCircle = 40000; //地球外周（km）
    const dataUrl = `https://${location.hostname}/wp-json/mobilitydata/v1/data`;
    const numImgSrc = $DataCount.find('img').eq(0).attr('src').replace('0.png', '$str$.png');

    function setError() {
      $DataBlock.removeClass('is-success');
      $DataBlock.addClass('is-error');
    }

    function setNum($target, numStr) {

      numStr += '';

      let count = 0;
      let hasPeriod = numStr.match(/[\.]+/);
      let numStrArr = numStr.split('');
      let setHtml = '';

      numStrArr.reverse();

      for (let i = 0; i < numStrArr.length; i++) {
        if (numStrArr[i].match(/[0-9\.]+/)) {
          if (!hasPeriod) {
            count++;
          }
          if (count !== 1 && count % 3 === 1) {
            setHtml = '<img src="' + numImgSrc.replace('$str$', 'comma') + '" class="comma">' + setHtml;
          }
          if (numStrArr[i] === '.') {
            hasPeriod = false;
            setHtml = '<img src="' + numImgSrc.replace('$str$', 'dot') + '">' + setHtml;
          } else {
            setHtml = '<img src="' + numImgSrc.replace('$str$', numStrArr[i]) + '">' + setHtml;
          }
        }
      }

      $target.html(setHtml);
    }

    function setData() {

      const date = new Date();
      const [year, month, day] = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
      $DataDate.text(`${year}年${month}月${day}日`);

      $.ajax({
        type: "GET",
        url: dataUrl,
        dataType: "json",
        cache: false,
        success: function(data){
          if(data.result.error && data.result.error==1){
            setError();
          } else {

            $DataBlock.addClass('is-success');
            $DataBlock.removeClass('is-error');

            //運行データ件数
            if(data.result.data.operation_data_count){
              setNum($DataCount,data.result.data.operation_data_count);
            }

            //総運行距離
            if(data.result.data.operation_distance_total){
              setNum($DataKm,data.result.data.operation_distance_total);

              //地球換算
              let earchCount = Math.floor(parseInt(data.result.data.operation_distance_total)/earthCircle*10)/10;
              setNum($DataEarth,earchCount);
            }

          }
        },
        error:function(){
          setError();
        }
      });

    }

    setInterval(setData, intervalTime);
    setData();
  });

})(jQuery);